// SVG Path for document icon
const SVG_PATH_DOCUMENT = "M170.779,146.549l-83.773,0c-4.4,0 -7.658,3.162 -7.658,7.284c0,4.248 3.259,7.537 7.658,7.537l83.773,0c4.273,0 7.46,-3.289 7.46,-7.537c0,-4.122 -3.187,-7.284 -7.46,-7.284Zm0,37.905l-83.773,0c-4.4,0 -7.658,3.314 -7.658,7.537c0,4.122 3.259,7.284 7.658,7.284l83.773,0c4.273,0 7.46,-3.162 7.46,-7.284c0,-4.223 -3.187,-7.537 -7.46,-7.537Zm-104.701,74.745l126.974,0c26.067,0 40.163,-14.194 40.163,-40.378l0,-108.336c0,-17.236 -2.537,-25.661 -13.461,-36.729l-59.628,-60.271c-10.639,-10.807 -19.518,-13.485 -35.753,-13.485l-58.296,0c-25.992,0 -40.092,14.194 -40.092,40.378l0,178.443c0,26.256 14.051,40.378 40.092,40.378Zm3.078,-27.177c-10.823,0 -15.994,-5.534 -15.994,-15.923l0,-173.002c0,-10.264 5.171,-15.923 16.066,-15.923l48.466,0l0,60.924c0,19.119 9.191,28.136 28.136,28.136l60.162,0l0,99.864c0,10.389 -5.196,15.923 -16.018,15.923l-120.818,0Zm78.818,-138.473c-5.26,-0 -7.665,-2.405 -7.665,-7.64l0,-56.2l63.15,63.84l-55.485,0Z";

function ResourcesBlock({ className }) {
    // Reusable resource button component with inline SVG
    const ResourceButton = ({ label, url, isLast }) => (
        <button
            className={`w-full h-12 border-none mx-auto p-0 flex flex-row items-center bg-transparent cursor-pointer group transition-colors duration-200 border-t border-neutral-300 dark:border-neutral-600 ${isLast ? 'border-b mb-4' : ''}`}
            onClick={() => window.open(url, '_blank')}
        >
            <svg 
                viewBox="0 0 260 260" 
                className="w-6 h-6 mr-2 fill-current text-neutral-600 dark:text-neutral-300 group-hover:text-[#FF671F] transition-colors duration-200"
            >
                <path d={SVG_PATH_DOCUMENT} />
            </svg>
            <h3 className="whitespace-nowrap overflow-hidden text-ellipsis text-left font-sans text-base font-semibold text-neutral-700 dark:text-neutral-200 group-hover:text-[#FF671F] transition-colors duration-200">
                {label}
            </h3>
        </button>
    );

    return (
        <div className={`w-full h-fit rounded-2xl flex flex-col bg-neutral-200 dark:bg-neutral-700 p-4 ${className || ''}`}>
            <h2 className="font-sans text-xl font-bold mb-2 text-neutral-700 dark:text-neutral-200">Resources</h2>
            <ResourceButton label="Challenge Details" url="/rules" />
            <ResourceButton label="Nutrition" url="/nutrition" />
            <ResourceButton label="FAQs" url="/faq" />
            <ResourceButton label="Technical Support" url="https://staff.elevationchurch.org/support/tickets/new?category=Software&sub_category=Account%20Access&subject=Everyday%20WAR-Ship" isLast />
        </div>
    );
}

export default ResourcesBlock;
